import { isProd } from "../env";

const env = process.env.NEXT_PUBLIC_DEPLOY_ENV || "prod";

// 判断服务端中是否需要请求me接口，如果没有sid则无需请求，默认用户没登陆
export const sidCheck = (cookie: string): boolean => {
  return cookie?.includes(isProd() ? "sid" : `sid.${env}`);
};

export const tokenCheck = (cookie: string): boolean => {
  return cookie?.includes(isProd() ? "token" : `token.${env}`);
};
